<template>
 <span class="type" :style="`color: ${answerStyleConfig.font.quColor}`">
   <slot></slot>
 </span>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'AnswerType',
  props: [],
  data () {
    return {

    }
  },
  components: {

  },
  watch: {
  },
  computed: {
    ...mapState({
      answerStyleConfig: ({ Question }) => Question.answerStyleConfig
    })
  },
  methods: {

  },
  created () {

  },
  mounted () {

  }
}
</script>



// WEBPACK FOOTER //
// src/components/answer/AnswerType.vue